import { Subscription } from 'rxjs/Rx';
import { GlobalvariableService } from './../../../services/globalvariable.service';
import { gengokbn } from '../../../plan/interface/gengokbn';
import { PlanMainService } from '../../../plan/service/plan-main.service';
import { SelectItem } from 'primeng/primeng';
import { CALENDAR_YEAR } from '../../../models/CALENDAR_YEAR';

import {
  Component,
  OnInit,
  Input,
  OnChanges,
  Output,
  EventEmitter,
  AfterViewInit,
  OnDestroy,
  AfterViewChecked
} from '@angular/core';
import { Subject } from 'rxjs/Subject';
import * as moment from 'moment';
import { UtilService } from '../../../services/util.service';

@Component({
  selector: 'app-dropdowncalendar',
  templateUrl: './dropdowncalendar.component.html',
  styleUrls: ['./dropdowncalendar.component.css']
})
export class DropdowncalendarComponent
  implements OnInit, OnChanges, OnDestroy {
  @Input() public date: Date = null;

  @Input() public selectdef: any = '';

  @Input() public formatdate: any = 'yy/mm/dd';

  @Input() public formatdateyear: string;

  @Input() public onicon: boolean = false;

  @Input() public hiddenDate: boolean = false;

  @Input() public dataDate: any;

  @Input() public databirthdayGengoKbn: number;

  @Input() public showfocusdatehidden: boolean = false;

  @Output() onInputs: EventEmitter<any> = new EventEmitter();

  @Output() onDatevalue: EventEmitter<any> = new EventEmitter();

  @Output() onselectDate: EventEmitter<any> = new EventEmitter();

  @Output() ondropDown: EventEmitter<any> = new EventEmitter();

  @Output() onfocusouts: EventEmitter<any> = new EventEmitter();

  @Input() defaultDate: string = 'ON';

  @Input() style: string;

  @Input() styletextbox: string;

  @Input() styledropdown: string;

  @Input() maxLength: number;

  @Input() inputId: string = null;

  @Input() inputIdselect: string;

  @Input() inputhidden: string = null;

  @Input() ondatelayout: boolean = false;

  @Output() onUpdateFocusEnter = new EventEmitter();

  @Output() sendid = new EventEmitter();

  @Input() showOnFocusDate: boolean = true;

  @Input() focusDate: boolean = false;

  @Input() readonly: boolean = false;

  @Input() readonlyhidden: boolean = false;

  @Input() disabledinput: boolean = false;

  @Output() focusId = new EventEmitter();

  @Input() removeDate: boolean = false;

  @Input() autoformat: boolean = false;

  @Output() onremoveDate = new EventEmitter();
  @Output() onfocus = new EventEmitter();
  @Output() onFocusDate = new EventEmitter();

  public statusyear: number = null;
  public modes: SelectItem[];
  public test: gengokbn[] = [];
  public js: any;
  public modeDate: any;
  public services: any;
  public currentDate: string;
  public datevalue: Date;
  public indexselect: number = 2;
  public opneModeinline = false;
  private gengoSubscription: Subscription;
  private componetDestroyed = new Subject();

  constructor(
    private _serviceplan: PlanMainService,
    private _globalvariableService: GlobalvariableService,
    private util: UtilService
  ) {}

  ngOnInit() {
    if (this.defaultDate == 'ON') {
      let today = new Date();
      today.setHours(0, 0, 0, 0);
      this.date = today;
    } else if (this.date == null) {
      this.dataDate = CALENDAR_YEAR.length - 1;
    }

    this.js = {
      firstDayOfWeek: 1,
      dayNames: [
        'げつようび',
        'かようび',
        'すいようび',
        'もくようび',
        'きんようび',
        'どようび',
        'にちようび'
      ],
      dayNamesShort: [
        '日曜日',
        '月曜日',
        '火曜日',
        '水曜日',
        '木曜日',
        '金曜日',
        '土曜日'
      ],
      dayNamesMin: ['日', '月', '火', '水', '木', '金', '土'],
      monthNames: [
        '1月',
        '2月',
        '3月',
        '4月',
        '5月',
        '6月',
        '7月',
        '8月',
        '9月',
        '10月',
        '11月',
        '12月'
      ],
      monthNamesShort: [
        '一月',
        '二月',
        '三月',
        '四月',
        '五月',
        '六月',
        '七月',
        '八月',
        '九月',
        '十月',
        '十一月',
        '十二月'
      ]
    };

    // this.gengoSubscription = this._serviceplan.getgengoKbn().subscribe((response: gengokbn[]) => {
    //   this.modes = [];
    //   this.test = response;
    //   if (this.selectdef != "H") {
    //     this.test.filter((val, i) => {
    //       if (val.gengoMark1 == this.selectdef)
    //         this.modeDate = this.test[i];
    //     });
    //   }
    // });

    this.services = this._globalvariableService.gengovalue;
    this.gengoSubscription = this.services.subscribe((response: gengokbn[]) => {
      this.modes = [];
      this.test = response;
      // this.test = [...response, {
      //   gengoMark1: 'R',
      //   gengoMark2: '令和',
      //   isWareki: 1,
      //   kbn: 3
      // }];

      if (this.selectdef != '') {
        this.test.filter((val, i) => {
          if (val.gengoMark1 == this.selectdef) {
            this.modeDate = this.test[i];
            this.indexselect = i;
            this.dataDate = this.test[i].kbn;
          }
        });
      } else {
        if (this.date) {
          const era = this.util.findEra(this.date);
          if (era) {
            this.selectdef = era.Char;
            this.modeDate = this.test[era.Kbn];
            this.indexselect = era.Kbn;
            this.dataDate =  era.Kbn;
          }
        } else {
          this.modeDate = this.test[this.dataDate];
        }
      }
    });
    this.checkDate();
    // this.onselectDate.emit({ value: this.date });
  }

  ngOnChanges() {
    // this.onRemoveDate();
    // this.checkDate();
    this.oncheckbirthdayGengoKbn();
    this.onfocustextbox();
  }

  // ngAfterViewInit() {
    // this.onRemoveDate();
    // this.valueChange();
  // }

  // ngAfterViewChecked() {
    // this.onRemoveDate();
    // this.checkDate();
  // }

  // valueChange() {
  //   const year = CALENDAR_YEAR.find(cal => cal.Char === this.selectdef);
  //   if (year) {
  //     this.dataDate = year.Kbn;
  //   } else {
  //     this.selectdef = null;
  //     this.dataDate = 0;
  //   }
  // }

  onChange() {
    //console.log("dropdowncalendar:onChange [START]");
    //console.log("onChange dataDate:" + this.dataDate);
    this.dataDate = this.modeDate.kbn;
    this.date = null;
    //console.log("onChange dataDate:" + this.dataDate);
    //console.log("dropdowncalendar:onChange [END]");
    this.ondropDown.emit({ value: this.modeDate });
  }

  onRemoveDate() {
    // this._dateconvertService.removeDate.subscribe(res => {
    //   if (res) {
    //     this.date = null;
    //     this.currentDate = null;
    //     this.modeDate = this.test[2];
    //     this.dataDate = 2;
    //     this.onremoveDate.emit(true);
    //   }
    // });
  }

  onSelectDate(event) {
    //console.log(event);
    // const date  : Date= event.value;
    // if(date.getFullYear() < 1988){
    //   this.test.filter((val, i) => {
    //     if (val.gengoMark1 == 'H') {
    //       this.modeDate = this.test[i];
    //       this.indexselect = i;
    //       this.dataDate = 2;
    //     }
    //   });
    // }else {

    // }

    // if()
    // this.onselectDate.emit({ value: this.date });
    if(event){
    this.onselectDate.emit({ value: event.value });
    }
  }

  getformet(value: any) {}

  ontextbox(event) {
    this.onInputs.emit(event);
  }

  keyEnter() {
    this.onUpdateFocusEnter.emit(true);
    if (this.inputId !== null) {
      (<HTMLInputElement>document.getElementById(this.inputId)).focus();
    } else {
      (<HTMLInputElement>document.getElementById(this.inputhidden)).focus();
    }
  }

  skipInput(e) {
    this.onUpdateFocusEnter.emit(true);
    if (this.inputhidden === 'sl-5') {
      this.focusId.emit('sl-6');
    }
    if (this.inputhidden === 'sl-8') {
      this.focusId.emit('sl-9');
    } else {
      e.target.blur();
    }
  }

  sendID() {
    this.sendid.emit('ageUnit');
    this.onUpdateFocusEnter.emit();
  }

  onDate(event) {
    this.currentDate = event.format;
    this.datevalue = event.value;
    if (this.date && event.value) {
      this.onDatevalue.emit({
        value: event.value,
        format: event.format,
        datestr: this._serviceplan.setStringdate('YYYYMM', event.value),
        datestr2: this._serviceplan.setStringdate('YYYYMMDD', event.value),
        invalid: event.invalid
      });
    } else {
      this.onDatevalue.emit({
        value: this.date,
        format: event.format,
        datestr: this._serviceplan.setStringdate('YYYYMM', this.date),
        datestr2: this._serviceplan.setStringdate('YYYYMMDD', this.date),
        invalid: event.invalid
      });
    }
  }

  onSwitch(event) {}

  onupdateDate(event) {
    this.date = null;
    let value = event.target.value;
    let valdatestring: string = value;
    let strvalue: string;
    let dateval = null;

    if (this.formatdate) {
      if (
        this.dataDate == 2 &&
        valdatestring.length == 6 &&
        this.formatdate != 'yy/mm'
      ) {
        this.formatdate = 'yy/mm/dd';
        this.statusyear = 2;
        strvalue =
          (
            this.getModeDate(this.dataDate) +
            Number(valdatestring.substring(0, 2))
          ).toString() +
          '/' +
          valdatestring.substring(2, 4) +
          '/' +
          valdatestring.substring(4, 6);
        // dateval = this._serviceplan.getDate(strvalue, 'YYYYMMDD');
      } else if (
        this.dataDate == 1 &&
        valdatestring.length == 6 &&
        this.formatdate != 'yy/mm'
      ) {
        this.formatdate = 'yy/mm/dd';
        this.statusyear = 2;
        strvalue =
          (
            this.getModeDate(this.dataDate) +
            Number(valdatestring.substring(0, 2))
          ).toString() +
          '/' +
          valdatestring.substring(2, 4) +
          '/' +
          valdatestring.substring(4, 6);
        // dateval = this._serviceplan.getDate(strvalue, 'YYYYMMDD');
      } else if (
        this.dataDate == 2 &&
        valdatestring.length == 8 &&
        this.formatdate != 'yy/mm'
      ) {
        this.formatdate = 'yy/mm/dd';
        this.statusyear = 2;
        strvalue =
          (
            this.getModeDate(this.dataDate) +
            Number(valdatestring.substring(0, 2))
          ).toString() +
          valdatestring.substring(2, 3) +
          valdatestring.substring(3, 5) +
          valdatestring.substring(5, 6) +
          valdatestring.substring(6, 8);
        // dateval = this._serviceplan.getDate(strvalue, "YYYYMMDD");
      } else if (
        this.dataDate == 1 &&
        valdatestring.length == 8 &&
        this.formatdate != 'yy/mm'
      ) {
        this.formatdate = 'yy/mm/dd';
        this.statusyear = 2;
        strvalue =
          (
            this.getModeDate(this.dataDate) +
            Number(valdatestring.substring(0, 2))
          ).toString() +
          valdatestring.substring(2, 3) +
          valdatestring.substring(3, 5) +
          valdatestring.substring(5, 6) +
          valdatestring.substring(6, 8);
        // dateval = this._serviceplan.getDate(strvalue, "YYYYMMDD");
      } else if (
        this.dataDate == 0 &&
        valdatestring.length == 8 &&
        this.formatdate != 'yy/mm'
      ) {
        this.formatdate = 'yy/mm/dd';
        this.statusyear = 2;
        strvalue =
          valdatestring.substring(0, 4) +
          '/' +
          valdatestring.substring(4, 6) +
          '/' +
          valdatestring.substring(6, 9);
        // dateval = this._serviceplan.getDate(strvalue, "YYYYMMDD");
      } else if (
        this.dataDate == 0 &&
        valdatestring.length == 10 &&
        this.formatdate != 'yy/mm'
      ) {
        this.formatdate = 'yy/mm/dd';
        this.statusyear = 2;
        strvalue =
          valdatestring.substring(0, 4) +
          valdatestring.substring(4, 5) +
          valdatestring.substring(5, 7) +
          valdatestring.substring(7, 8) +
          valdatestring.substring(8, 10);
        // dateval = this._serviceplan.getDate(strvalue, "YYYYMMDD");
      } else if (this.dataDate == 2 && valdatestring.length == 4) {
        this.formatdate = 'yy/mm';
        this.statusyear = 0;
        strvalue =
          (
            this.getModeDate(this.dataDate) +
            Number(valdatestring.substring(0, 2))
          ).toString() +
          '/' +
          valdatestring.substring(2, 4) +
          '/' +
          '01';

        // if (this.passValidDate(strvalue)) {
        //   dateval = this._serviceplan.getDate(strvalue, 'YYYYMMDD');
        // } else {
        //   this.date = null;
        //   this.currentDate = null;
        // }
      } else if (this.dataDate == 1 && valdatestring.length == 4) {
        this.formatdate = 'yy/mm';
        this.statusyear = 0;
        strvalue =
          (
            this.getModeDate(this.dataDate) +
            Number(valdatestring.substring(0, 2))
          ).toString() +
          '/' +
          valdatestring.substring(2, 4) +
          '/' +
          '01';
        // dateval = this._serviceplan.getDate(strvalue, 'YYYYMMDD');
      } else if (this.dataDate == 0 && valdatestring.length == 6) {
        this.formatdate = 'yy/mm';
        this.statusyear = 0;
        strvalue =
          valdatestring.substring(0, 4) +
          '/' +
          valdatestring.substring(4, 6) +
          '/' +
          '01';
        // dateval = this._serviceplan.getDate(strvalue, 'YYYYMMDD');
      } else if (this.dataDate == 2 && valdatestring.length == 5) {
        this.formatdate = 'yy/mm';
        this.statusyear = 0;
        strvalue =
          (
            this.getModeDate(this.dataDate) +
            Number(valdatestring.substring(0, 2))
          ).toString() +
          valdatestring.substring(2, 3) +
          valdatestring.substring(3, 5) +
          '/' +
          '01';
        // dateval = this._serviceplan.getDate(strvalue, 'YYYYMMDD');
      } else if (this.dataDate == 1 && valdatestring.length == 5) {
        this.formatdate = 'yy/mm';
        this.statusyear = 0;
        strvalue =
          (
            this.getModeDate(this.dataDate) +
            Number(valdatestring.substring(0, 2))
          ).toString() +
          valdatestring.substring(2, 3) +
          valdatestring.substring(3, 5) +
          '/' +
          '01';
        // dateval = this._serviceplan.getDate(strvalue, 'YYYYMMDD');
      } else if (this.dataDate == 0 && valdatestring.length == 7) {
        this.formatdate = 'yy/mm';
        this.statusyear = 0;
        strvalue =
          (
            this.getModeDate(this.dataDate) +
            Number(valdatestring.substring(0, 4))
          ).toString() +
          valdatestring.substring(4, 5) +
          valdatestring.substring(5, 7) +
          '/' +
          '01';
        // dateval = this._serviceplan.getDate(strvalue, 'YYYYMMDD');
      } else if (this.dataDate == 2 && valdatestring.length == 2) {
        this.formatdate = 'yy';
        this.statusyear = 1;
        strvalue =
          (
            this.getModeDate(this.dataDate) +
            Number(valdatestring.substring(0, 4))
          ).toString() +
          '/' +
          '01' +
          '/' +
          '01';
      } else if (this.dataDate == 1 && valdatestring.length == 2) {
        this.formatdate = 'yy';
        this.statusyear = 1;
        strvalue =
          (
            this.getModeDate(this.dataDate) +
            Number(valdatestring.substring(0, 4))
          ).toString() +
          '/' +
          '01' +
          '/' +
          '01';
      } else if (this.dataDate == 0 && valdatestring.length == 4) {
        this.formatdate = 'yy';
        this.statusyear = 1;
        strvalue = valdatestring.substring(0, 4) + '/' + '01' + '/' + '01';
      }
    } else {
      if (this.dataDate == 2 && valdatestring.length == 6) {
        this.formatdate = 'yy/mm/dd';
        this.statusyear = 2;
        strvalue =
          (
            this.getModeDate(this.dataDate) +
            Number(valdatestring.substring(0, 2))
          ).toString() +
          '/' +
          valdatestring.substring(2, 4) +
          '/' +
          valdatestring.substring(4, 6);
        // dateval = this._serviceplan.getDate(strvalue, 'YYYYMMDD');
      } else if (this.dataDate == 1 && valdatestring.length == 6) {
        this.formatdate = 'yy/mm/dd';
        this.statusyear = 2;
        strvalue =
          (
            this.getModeDate(this.dataDate) +
            Number(valdatestring.substring(0, 2))
          ).toString() +
          '/' +
          valdatestring.substring(2, 4) +
          '/' +
          valdatestring.substring(4, 6);
        // dateval = this._serviceplan.getDate(strvalue, 'YYYYMMDD');
      } else if (this.dataDate == 2 && valdatestring.length == 8) {
        this.formatdate = 'yy/mm/dd';
        this.statusyear = 2;
        strvalue =
          (
            this.getModeDate(this.dataDate) +
            Number(valdatestring.substring(0, 2))
          ).toString() +
          valdatestring.substring(2, 3) +
          valdatestring.substring(3, 5) +
          valdatestring.substring(5, 6) +
          valdatestring.substring(6, 8);
        // dateval = this._serviceplan.getDate(strvalue, "YYYYMMDD");
      } else if (this.dataDate == 1 && valdatestring.length == 8) {
        this.formatdate = 'yy/mm/dd';
        this.statusyear = 2;
        strvalue =
          (
            this.getModeDate(this.dataDate) +
            Number(valdatestring.substring(0, 2))
          ).toString() +
          valdatestring.substring(2, 3) +
          valdatestring.substring(3, 5) +
          valdatestring.substring(5, 6) +
          valdatestring.substring(6, 8);
        // dateval = this._serviceplan.getDate(strvalue, "YYYYMMDD");
      } else if (this.dataDate == 0 && valdatestring.length == 8) {
        this.formatdate = 'yy/mm/dd';
        this.statusyear = 2;
        strvalue =
          valdatestring.substring(0, 4) +
          '/' +
          valdatestring.substring(4, 6) +
          '/' +
          valdatestring.substring(6, 9);
        // dateval = this._serviceplan.getDate(strvalue, "YYYYMMDD");
      } else if (this.dataDate == 0 && valdatestring.length == 10) {
        this.formatdate = 'yy/mm/dd';
        this.statusyear = 2;
        strvalue =
          valdatestring.substring(0, 4) +
          valdatestring.substring(4, 5) +
          valdatestring.substring(5, 7) +
          valdatestring.substring(7, 8) +
          valdatestring.substring(8, 10);
        // dateval = this._serviceplan.getDate(strvalue, "YYYYMMDD");
      } else if (this.dataDate == 2 && valdatestring.length == 4) {
        this.formatdate = 'yy/mm';
        this.statusyear = 0;
        strvalue =
          (
            this.getModeDate(this.dataDate) +
            Number(valdatestring.substring(0, 2))
          ).toString() +
          '/' +
          valdatestring.substring(2, 4) +
          '/' +
          '01';

        // if (this.passValidDate(strvalue)) {
        //   dateval = this._serviceplan.getDate(strvalue, 'YYYYMMDD');
        // } else {
        //   this.date = null;
        //   this.currentDate = null;
        // }
      } else if (this.dataDate == 1 && valdatestring.length == 4) {
        this.formatdate = 'yy/mm';
        this.statusyear = 0;
        strvalue =
          (
            this.getModeDate(this.dataDate) +
            Number(valdatestring.substring(0, 2))
          ).toString() +
          '/' +
          valdatestring.substring(2, 4) +
          '/' +
          '01';
        // dateval = this._serviceplan.getDate(strvalue, 'YYYYMMDD');
      } else if (this.dataDate == 0 && valdatestring.length == 6) {
        this.formatdate = 'yy/mm';
        this.statusyear = 0;
        strvalue =
          valdatestring.substring(0, 4) +
          '/' +
          valdatestring.substring(4, 6) +
          '/' +
          '01';
        // dateval = this._serviceplan.getDate(strvalue, 'YYYYMMDD');
      } else if (this.dataDate == 2 && valdatestring.length == 5) {
        this.formatdate = 'yy/mm';
        this.statusyear = 0;
        strvalue =
          (
            this.getModeDate(this.dataDate) +
            Number(valdatestring.substring(0, 2))
          ).toString() +
          valdatestring.substring(2, 3) +
          valdatestring.substring(3, 5) +
          '/' +
          '01';
        // dateval = this._serviceplan.getDate(strvalue, 'YYYYMMDD');
      } else if (this.dataDate == 1 && valdatestring.length == 5) {
        this.formatdate = 'yy/mm';
        this.statusyear = 0;
        strvalue =
          (
            this.getModeDate(this.dataDate) +
            Number(valdatestring.substring(0, 2))
          ).toString() +
          valdatestring.substring(2, 3) +
          valdatestring.substring(3, 5) +
          '/' +
          '01';
        // dateval = this._serviceplan.getDate(strvalue, 'YYYYMMDD');
      } else if (this.dataDate == 0 && valdatestring.length == 7) {
        this.formatdate = 'yy/mm';
        this.statusyear = 0;
        strvalue =
          (
            this.getModeDate(this.dataDate) +
            Number(valdatestring.substring(0, 4))
          ).toString() +
          valdatestring.substring(4, 5) +
          valdatestring.substring(5, 7) +
          '/' +
          '01';
        // dateval = this._serviceplan.getDate(strvalue, 'YYYYMMDD');
      } else if (this.dataDate == 2 && valdatestring.length == 2) {
        this.formatdate = 'yy';
        this.statusyear = 1;
        strvalue =
          (
            this.getModeDate(this.dataDate) +
            Number(valdatestring.substring(0, 4))
          ).toString() +
          '/' +
          '01' +
          '/' +
          '01';
      } else if (this.dataDate == 1 && valdatestring.length == 2) {
        this.formatdate = 'yy';
        this.statusyear = 1;
        strvalue =
          (
            this.getModeDate(this.dataDate) +
            Number(valdatestring.substring(0, 4))
          ).toString() +
          '/' +
          '01' +
          '/' +
          '01';
      } else if (this.dataDate == 0 && valdatestring.length == 4) {
        this.formatdate = 'yy';
        this.statusyear = 1;
        strvalue = valdatestring.substring(0, 4) + '/' + '01' + '/' + '01';
      }
    }

    if (this.passValidDate(strvalue)) {
      this.date = this._serviceplan.getDate(strvalue, 'YYYYMMDD');
    } else {
      this.date = null;
      this.currentDate = null;
    }
  }

  onfocusout(event) {
    // this.date = null;
    this.date = null;
    let value = event.target.value;
    let valdatestring: string = value;
    let strvalue: string;
    let dateval = null;

    // this.oncheckMaxLength(value);

    if (this.formatdate) {
      if (
        this.dataDate > 0 &&
        valdatestring.length == 6 &&
        this.formatdate != 'yy/mm' &&
        this.formatdate != 'yy'
      ) {
        this.formatdate = 'yy/mm/dd';
        this.statusyear = 2;
        strvalue =
          (
            this.getModeDate(this.dataDate) +
            Number(valdatestring.substring(0, 2))
          ).toString() +
          '/' +
          valdatestring.substring(2, 4) +
          '/' +
          valdatestring.substring(4, 6);
        // dateval = this._serviceplan.getDate(strvalue, 'YYYYMMDD');
      } else if (
        this.dataDate == 2 &&
        valdatestring.length == 8 &&
        this.formatdate != 'yy/mm' &&
        this.formatdate != 'yy'
      ) {
        this.formatdate = 'yy/mm/dd';
        this.statusyear = 2;
        strvalue =
          (
            this.getModeDate(this.dataDate) +
            Number(valdatestring.substring(0, 2))
          ).toString() +
          valdatestring.substring(2, 3) +
          valdatestring.substring(3, 5) +
          valdatestring.substring(5, 6) +
          valdatestring.substring(6, 8);
        // dateval = this._serviceplan.getDate(strvalue, "YYYYMMDD");
      } else if (
        this.dataDate == 1 &&
        valdatestring.length == 8 &&
        this.formatdate != 'yy/mm' &&
        this.formatdate != 'yy'
      ) {
        this.formatdate = 'yy/mm/dd';
        this.statusyear = 2;
        strvalue =
          (
            this.getModeDate(this.dataDate) +
            Number(valdatestring.substring(0, 2))
          ).toString() +
          valdatestring.substring(2, 3) +
          valdatestring.substring(3, 5) +
          valdatestring.substring(5, 6) +
          valdatestring.substring(6, 8);
        // dateval = this._serviceplan.getDate(strvalue, "YYYYMMDD");
      } else if (
        this.dataDate == 0 &&
        valdatestring.length == 8 &&
        this.formatdate != 'yy/mm' &&
        this.formatdate != 'yy'
      ) {
        this.formatdate = 'yy/mm/dd';
        this.statusyear = 2;
        strvalue =
          valdatestring.substring(0, 4) +
          '/' +
          valdatestring.substring(4, 6) +
          '/' +
          valdatestring.substring(6, 9);
        // dateval = this._serviceplan.getDate(strvalue, "YYYYMMDD");
      } else if (
        this.dataDate == 0 &&
        valdatestring.length == 10 &&
        this.formatdate != 'yy/mm' &&
        this.formatdate != 'yy'
      ) {
        this.formatdate = 'yy/mm/dd';
        this.statusyear = 2;
        strvalue =
          valdatestring.substring(0, 4) +
          valdatestring.substring(4, 5) +
          valdatestring.substring(5, 7) +
          valdatestring.substring(7, 8) +
          valdatestring.substring(8, 10);
        // dateval = this._serviceplan.getDate(strvalue, "YYYYMMDD");
      } else if (this.dataDate > 0 && valdatestring.length == 4) {
        this.formatdate = 'yy/mm';
        this.statusyear = 0;
        strvalue =
          (
            this.getModeDate(this.dataDate) +
            Number(valdatestring.substring(0, 2))
          ).toString() +
          '/' +
          valdatestring.substring(2, 4) +
          '/' +
          '01';

        // if (this.passValidDate(strvalue)) {
        //   dateval = this._serviceplan.getDate(strvalue, 'YYYYMMDD');
        // } else {
        //   this.date = null;
        //   this.currentDate = null;
        // }
      } else if (this.dataDate == 0 && valdatestring.length == 6) {
        this.formatdate = 'yy/mm';
        this.dataDate = 0;
        this.statusyear = 0;
        strvalue =
          valdatestring.substring(0, 4) +
          '/' +
          valdatestring.substring(4, 6) +
          '/' +
          '01';
        // dateval = this._serviceplan.getDate(strvalue, 'YYYYMMDD');
      } else if (this.dataDate > 0 && valdatestring.length == 5) {
        this.formatdate = 'yy/mm';
        this.statusyear = 0;
        strvalue =
          (
            this.getModeDate(this.dataDate) +
            Number(valdatestring.substring(0, 2))
          ).toString() +
          valdatestring.substring(2, 3) +
          valdatestring.substring(3, 5) +
          '/' +
          '01';
        // dateval = this._serviceplan.getDate(strvalue, 'YYYYMMDD');
      } else if (this.dataDate == 0 && valdatestring.length == 7) {
        this.formatdate = 'yy/mm';
        this.statusyear = 0;
        strvalue =
          (
            this.getModeDate(this.dataDate) +
            Number(valdatestring.substring(0, 4))
          ).toString() +
          valdatestring.substring(4, 5) +
          valdatestring.substring(5, 7) +
          '/' +
          '01';
        // dateval = this._serviceplan.getDate(strvalue, 'YYYYMMDD');
      } else if (this.dataDate > 0 && valdatestring.length == 2) {
        this.formatdate = 'yy';
        this.statusyear = 1;
        strvalue =
          (
            this.getModeDate(this.dataDate) +
            Number(valdatestring.substring(0, 4))
          ).toString() +
          '/' +
          '01' +
          '/' +
          '01';
      } else if (this.dataDate == 0 && valdatestring.length == 4) {
        this.formatdate = 'yy';
        this.statusyear = 1;
        strvalue = valdatestring.substring(0, 4) + '/' + '01' + '/' + '01';
      } else if (this.dataDate > 0 && valdatestring.length == 1) {
        if (Number(valdatestring.substring(0, 4)) != 0) {
          this.formatdate = 'yy';
          this.statusyear = 1;
          strvalue =
            (
              this.getModeDate(this.dataDate) +
              Number(valdatestring.substring(0, 4))
            ).toString() +
            '/' +
            '01' +
            '/' +
            '01';
        }
      }
    } else {
      if (this.dataDate > 0 && valdatestring.length == 6) {
        this.formatdate = 'yy/mm/dd';
        this.statusyear = 2;
        strvalue =
          (
            this.getModeDate(this.dataDate) +
            Number(valdatestring.substring(0, 2))
          ).toString() +
          '/' +
          valdatestring.substring(2, 4) +
          '/' +
          valdatestring.substring(4, 6);
        // dateval = this._serviceplan.getDate(strvalue, 'YYYYMMDD');
      } else if (this.dataDate > 0 && valdatestring.length == 8) {
        this.formatdate = 'yy/mm/dd';
        this.statusyear = 2;
        strvalue =
          (
            this.getModeDate(this.dataDate) +
            Number(valdatestring.substring(0, 2))
          ).toString() +
          valdatestring.substring(2, 3) +
          valdatestring.substring(3, 5) +
          valdatestring.substring(5, 6) +
          valdatestring.substring(6, 8);
        // dateval = this._serviceplan.getDate(strvalue, "YYYYMMDD");
      } else if (this.dataDate == 0 && valdatestring.length == 8) {
        this.formatdate = 'yy/mm/dd';
        this.statusyear = 2;
        strvalue =
          valdatestring.substring(0, 4) +
          '/' +
          valdatestring.substring(4, 6) +
          '/' +
          valdatestring.substring(6, 9);
        // dateval = this._serviceplan.getDate(strvalue, "YYYYMMDD");
      } else if (this.dataDate == 0 && valdatestring.length == 10) {
        this.formatdate = 'yy/mm/dd';
        this.statusyear = 2;
        strvalue =
          valdatestring.substring(0, 4) +
          valdatestring.substring(4, 5) +
          valdatestring.substring(5, 7) +
          valdatestring.substring(7, 8) +
          valdatestring.substring(8, 10);
        // dateval = this._serviceplan.getDate(strvalue, "YYYYMMDD");
      } else if (this.dataDate > 0 && valdatestring.length == 4) {
        this.formatdate = 'yy/mm';
        this.statusyear = 0;
        strvalue =
          (
            this.getModeDate(this.dataDate) +
            Number(valdatestring.substring(0, 2))
          ).toString() +
          '/' +
          valdatestring.substring(2, 4) +
          '/' +
          '01';
        // dateval = this._serviceplan.getDate(strvalue, 'YYYYMMDD');
      } else if (this.dataDate == 0 && valdatestring.length == 6) {
        this.formatdate = 'yy/mm';
        this.dataDate = 0;
        this.statusyear = 0;
        strvalue =
          valdatestring.substring(0, 4) +
          '/' +
          valdatestring.substring(4, 6) +
          '/' +
          '01';
        // dateval = this._serviceplan.getDate(strvalue, 'YYYYMMDD');
      } else if (this.dataDate > 0 && valdatestring.length == 5) {
        this.formatdate = 'yy/mm';
        this.statusyear = 0;
        strvalue =
          (
            this.getModeDate(this.dataDate) +
            Number(valdatestring.substring(0, 2))
          ).toString() +
          valdatestring.substring(2, 3) +
          valdatestring.substring(3, 5) +
          '/' +
          '01';
        // dateval = this._serviceplan.getDate(strvalue, 'YYYYMMDD');
      } else if (this.dataDate == 0 && valdatestring.length == 7) {
        this.formatdate = 'yy/mm';
        this.statusyear = 0;
        strvalue =
          (
            this.getModeDate(this.dataDate) +
            Number(valdatestring.substring(0, 4))
          ).toString() +
          valdatestring.substring(4, 5) +
          valdatestring.substring(5, 7) +
          '/' +
          '01';
        // dateval = this._serviceplan.getDate(strvalue, 'YYYYMMDD');
      } else if (this.dataDate > 0 && valdatestring.length == 2) {
        this.formatdate = 'yy';
        this.statusyear = 1;
        strvalue =
          (
            this.getModeDate(this.dataDate) +
            Number(valdatestring.substring(0, 4))
          ).toString() +
          '/' +
          '01' +
          '/' +
          '01';
      } else if (this.dataDate == 0 && valdatestring.length == 4) {
        this.formatdate = 'yy';
        this.statusyear = 1;
        strvalue = valdatestring.substring(0, 4) + '/' + '01' + '/' + '01';
      } else if (this.dataDate > 0 && valdatestring.length == 1) {
        if (Number(valdatestring.substring(0, 4)) != 0) {
          this.formatdate = 'yy';
          this.statusyear = 1;
          strvalue =
            (
              this.getModeDate(this.dataDate) +
              Number(valdatestring.substring(0, 4))
            ).toString() +
            '/' +
            '01' +
            '/' +
            '01';
        }
      }
    }

    if (this.passValidDate(strvalue)) {
      this.date = this._serviceplan.getDate(strvalue, 'YYYYMMDD');
      if (this.date != null && this.date != undefined) {
        this.onfocusouts.emit({
          value: this.date,
          format: this._serviceplan.setStringdate('YYYY/MM', this.date),
          datestr: this._serviceplan.setStringdate('YYYYMM', this.date),
          datestr2: this._serviceplan.setStringdate('YYYYMMDD', this.date),
          datestryear: this._serviceplan.setStringdate('YYYY', this.date),
          statusyear: this.statusyear,
          modeDate: this.modeDate
        });
      }
    } else {
      this.date = null;
      this.currentDate = null;
      this.onfocusouts.emit(null);
    }
  }

  passValidDate(date) {
    return moment(date, 'YYYY/MM/DD', true).isValid();
  }

  getModeDate(mode: any): number {
    if (CALENDAR_YEAR[mode]) {
      return CALENDAR_YEAR[mode].Diff;
    }
    return 0;
  }

  // oncheckMaxLength() {
  //   if (this.maxLength) {
  //     if (this.dataDate === 2 && this.dataDate === 1) {
  //       if (this.formatdate == 'yy/mm') {
  //       }
  //     } else {
  //     }
  //   }
  // }

  onmodedropdown(event) {
  //  if (event != 'H') {
  //    this.test.filter((val, i) => {
  //      if (val.gengoMark1 == event) this.modeDate = this.test[i];
  //    });
  //  } else {
  //    this.test.filter((val, i) => {
  //      if (val.gengoMark1 == 'H') this.modeDate = this.test[i];
  //    });
  //  }
  // console.log("dropdowncalendar: onmodedropdown[START]");
    // if (event === 'H') {
    //   this.modeDate = this.test[2];
    //   this.dataDate = 2;
    // } else if (event === 'S') {
    //   this.modeDate = this.test[1];
    //   this.dataDate = 1;
    // } else {
    //   this.modeDate = this.test[0];
    //   this.dataDate = 0;
    // }
    if (this.test.length > 0) {
      const foundMode = this.test.find(val => val.gengoMark1 === event);
      if (foundMode) {
        this.modeDate = foundMode;
        this.dataDate = foundMode.kbn;
      } else {
        this.modeDate = this.test[0];
        this.dataDate = 0;
      }
    }
  }

  checkDate() {
    if (this.date) {
      const era: any = this.util.findEra(this.date);
      if (era) {
        this.indexselect = era.Kbn;
        this.modeDate = {
          gengoMark1: era.Char,
          gengoMark2: era.YearNm,
          isWareki: 1, kbn: era.Kbn
        };
        this.dataDate = era.Kbn;
      } else {
        this.indexselect = 0;
        this.modeDate = this.test[0];
        this.dataDate = 0;
      }
    }
  }

  onBlur(event) {
    //console.log("dropdowncalendar:onBlur [START]");
    //console.log(event);
    if (event && event.value != '' && event.value != null) {
      if (this.autoformat) {
        this.statusyear = event.statusyear;
      }
      //console.log("dropdowncalendar:onBlur event(true)");
      this.onfocusouts.emit({
        value: event.value,
        format: this._serviceplan.setStringdate('YYYY/MM', event.value),
        datestr: this._serviceplan.setStringdate('YYYYMM', event.value),
        datestr2: this._serviceplan.setStringdate('YYYYMMDD', event.value),
        datestryear: this._serviceplan.setStringdate('YYYY', event.value),
        statusyear: this.statusyear,
        modeDate: this.modeDate,
        eventinput: event.eventinput
      });
    } else {
      //console.log("dropdowncalendar:onBlur event(false)");
      // this.date = null;
      // this.currentDate = null;
      // if (event && event.eventinput) {
      //   this.onupdateDate({target: {value: event.eventinput}});
      //   // console.log(this.date);
      //   this.onfocusouts.emit({
      //     value: null,
      //     modeDate: this.modeDate,
      //     datestr: this._serviceplan.setStringdate('YYYYMM', this.date),
      //     datestryear: this._serviceplan.setStringdate('YYYY', this.date),
      //     statusyear: this.statusyear,
      //     eventinput: event.eventinput
      //   });
      //   this.date = null;
      //   this.currentDate = null;
      // } else {
        this.onfocusouts.emit(null);
      // }
    }
    //console.log("dropdowncalendar:onBlur [END]");
  }

  swapArray(Array: any, Swap1: number, Swap2: number): any {
    var temp = Array[Swap1];
    Array[Swap1] = Array[Swap2];
    Array[Swap2] = temp;
    return Array;
  }

  focus() {
    this.onfocus.emit();
  }

  onkeypress(event) {
    const strInput = event.target.value.replace(/\//g, '');
    let max = this.maxLength;
    if (this.dataDate > 0) {
      max -= 2;
    }
    if (event.charCode > 0 && max != null && strInput.length >= max) {
      return false;
    }
  }

  oncheckbirthdayGengoKbn() {
    if (this.databirthdayGengoKbn) {
      this.test.filter((val, i) => {
        if (val.kbn === this.databirthdayGengoKbn) {
          this.modeDate = this.test[i];
          this.indexselect = i;
          this.dataDate = this.test[i].kbn;
        }
      });
    }
  }

  checkdateinput(datemeate: string) {
    const strdate = datemeate.replace('\\', '');
    const datedata = this._serviceplan.getDate(strdate, 'YYYYMMDD');
    const era = this.util.findEra(datedata);
    if (era) {
      this.dataDate = era.Kbn;
    } else {
      this.dataDate = 0;
    }
  }

  onfocustextbox() {
    if (this.showfocusdatehidden) {
      (<HTMLInputElement>document.getElementById(this.inputhidden)).focus();
    }
  }

  setFocusDate(event) {
    this.onFocusDate.emit(event);
  }

  ngOnDestroy() {
    this.componetDestroyed.next();
    this.componetDestroyed.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/dropdowncalendar/dropdowncalendar.component.ts